import * as tslib_1 from "tslib";
import { ApiService } from "./api.service";
export class AppService {
    constructor(apiService) {
        this.apiService = apiService;
        this.loading = "";
        this.notification = "test";
        this.notificationClass = "";
        this.notificationTimer = null;
        this.CONFIG_STORAGE_KEY = 'app_config';
    }
    // Getter that automatically loads config if null
    static get config() {
        return AppService._config;
    }
    // Setter for config
    static set config(value) {
        AppService._config = value;
    }
    // Method to safely get config with automatic loading
    getConfig() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!AppService.config) {
                yield this.loadConfig();
            }
            return AppService.config;
        });
    }
    loadConfig() {
        return new Promise((resolve, reject) => {
            // First try to load from localStorage
            const savedConfig = this.loadConfigFromStorage();
            if (savedConfig) {
                AppService.config = savedConfig;
                resolve();
                return;
            }
            // Fallback to loading from API/assets
            this.apiService.loadAppConfig().subscribe((config) => {
                AppService.config = config;
                // Save to localStorage for future use
                this.saveConfigToStorage(config);
                resolve();
            }, (error) => {
                console.error('Failed to load app config:', error);
                reject(error);
            });
        });
    }
    changeConfig(config) {
        AppService.config = config;
        // Save configuration to localStorage for persistence
        this.saveConfigToStorage(config);
        // Show notification that config was saved
        this.showNotification('Configuration saved successfully');
    }
    saveConfigToStorage(config) {
        try {
            const configString = JSON.stringify(config, null, 2);
            localStorage.setItem(this.CONFIG_STORAGE_KEY, configString);
        }
        catch (error) {
            console.error('Failed to save config to localStorage:', error);
        }
    }
    loadConfigFromStorage() {
        try {
            const configString = localStorage.getItem(this.CONFIG_STORAGE_KEY);
            if (configString) {
                return JSON.parse(configString);
            }
        }
        catch (error) {
            console.error('Failed to load config from localStorage:', error);
        }
        return null;
    }
    showNotification(s) {
        if (this.notificationTimer) {
            clearTimeout(this.notificationTimer);
        }
        this.notification = s;
        this.notificationClass = "active";
        this.notificationTimer = setTimeout(() => {
            this.notificationClass = "";
            this.notificationTimer = null;
        }, 2000);
    }
}
AppService._config = null;
